import prefixHttps from '~utils/prefixHttps';
import split from './stringSplit';

const sanitizeIcon = (dto: ApiIconResponse): Icon => {
  const tags = split(dto.free_tags);
  return {
    id: dto.id,
    title: dto.title,
    iconUrl: prefixHttps(dto.url),
    previewUrl: prefixHttps(dto.preview || dto.url),
    tags,
    filename: dto.filename,
    searchStack: [dto.title, dto.filename, tags].join(' ').toLowerCase().trim(),
  };
};

export default sanitizeIcon;
